import { Button } from "@themes/pollinator/ui/Button";
import { SectionHeading } from "@themes/pollinator/ui/SectionHeading";
import { Type } from "@themes/pollinator/ui/Type";
import { INVITATION_TYPE, type PendingInvitation } from "@core/features/invitation";

export type Props = {
  invitations: PendingInvitation[];
  onClaim: (shortcode: string) => void;
  claimingShortcode: string | null;
};

export function PendingInvitationsList({
  invitations,
  onClaim,
  claimingShortcode,
}: Props) {
  if (invitations.length === 0) {
    return null;
  }

  return (
    <SectionHeading
      title="Pending Invitations"
      description="You have been invited to join the following:"
    >
      <div className="flex flex-col gap-4">
        {invitations.map((invitation) => {
          const isClaiming = claimingShortcode === invitation.shortcode;
          const label =
            invitation.invitation_type === INVITATION_TYPE.ORG_ADMIN_PRIMARY
              ? "Primary Organization Admin"
              : invitation.invitation_type === INVITATION_TYPE.ORG_ADMIN
                ? "Organization Admin"
                : invitation.invitation_type === INVITATION_TYPE.PARTICIPANT
                  ? "Participant"
                  : null;

          return (
            <div
              key={invitation.id}
              className="flex items-center justify-between gap-4 rounded-lg border border-brand-800 p-4"
            >
              <div className="flex flex-col gap-1">
                <Type as="p" variant="h5">
                  {invitation.program_name}
                </Type>
                {invitation.organization_name && (
                  <Type as="p" variant="body2">
                    {invitation.organization_name}
                  </Type>
                )}
                {label && (
                  <Type as="p" variant="caption">
                    {label}
                  </Type>
                )}
              </div>
              <Button
                variant="primary"
                onClick={() => onClaim(invitation.shortcode)}
                isLoading={isClaiming}
                disabled={!!claimingShortcode}
              >
                Accept
              </Button>
            </div>
          );
        })}
      </div>
    </SectionHeading>
  );
}

export default PendingInvitationsList;
